import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function sopTriggerHandler(params) {
  return request({
    url: URL.booking.sopTriggerHandler,
    method: 'get',
    params
  })
}
